import { AnyAction } from 'redux';
import * as actionTypes from '../../../../models/actionTypes';
import { initialOcvState, IOcvState } from '../../../../models/reduxState';

const handleSupportDataGrabSuccess = (
  state: IOcvState = initialOcvState,
  action: AnyAction
): IOcvState => {
  return {
    ...state,
    IsEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.IsEnabled,
    AppId: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.AppId ? action.supportSettingsConfig.OcvConfig.AppId : 0,
    Environment: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && action.supportSettingsConfig.OcvConfig.Environment != null ? action.supportSettingsConfig.OcvConfig.Environment : -1,
    StylesUrl: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.StylesUrl ? action.supportSettingsConfig.OcvConfig.StylesUrl : '',
    IntlUrl: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.IntlUrl ? action.supportSettingsConfig.OcvConfig.IntlUrl : '',
    ShowEmailAddress: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.ShowEmailAddress,
    ShowScreenshot: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.ShowScreenshot,
    ShowScreenRecording: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.ShowScreenRecording,
    ShowFileUpload: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.ShowFileUpload,
    IsOcvVNextEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.IsOcvVNextEnabled,
    IsSendAimIdEnabled: !!action.supportSettingsConfig && !!action.supportSettingsConfig.OcvConfig && !!action.supportSettingsConfig.OcvConfig.IsSendAimIdEnabled,
  };
};

const handleSetInitializedOcv = (
  state: IOcvState = initialOcvState,
): IOcvState => {
  return {
    ...state,
    IsInitialized: true,
  };
};

export const OcvReducer = (
  state: IOcvState = initialOcvState,
  action: AnyAction
): IOcvState => {
  switch (action.type) {
    case actionTypes.GET_EMERALD_SUPPORTCONFIG_SUCCESS:
    case actionTypes.GET_EMERALD_CONFIG_SUCCESS:
      return handleSupportDataGrabSuccess(state, action);
    case actionTypes.SET_ISINITIALIZED_OCV:
      return handleSetInitializedOcv(state);
    default:
      return state;
  }
};
